<template>
    <AppDialog :model-value="props.modelValue" @update:model-value="emit('update:modelValue', $event)">
        <div class="p-4 space-y-4">
            <h3 class="text-center font-semibold text-lg">{{ t('scanner.specialWarning') }}</h3>
            <div class="text-center text-2xl">{{ ticketsetName }}</div>
            <div class="flex items-center justify-between gap-2 pt-2">
                <AppButton variant="danger" large @click="refuse">{{ t('scanner.refuse') }}</AppButton>
                <AppButton variant="success" large @click="confirm">{{ t('scanner.confirm') }}</AppButton>
            </div>
        </div>
    </AppDialog>
</template>

<script setup lang="ts">
    import { useI18n } from 'vue-i18n'
    import AppDialog from '@/components/ui/AppDialog.vue'
    import AppButton from '@/components/ui/AppButton.vue'

    const props = defineProps<{
        modelValue: boolean
        ticketsetName: string
    }>()

    const emit = defineEmits<{
        'update:modelValue': [value: boolean]
        confirm: []
        refuse: []
    }>()

    const { t } = useI18n()

    function refuse() {
        emit('refuse')
        emit('update:modelValue', false)
    }
    function confirm() {
        emit('confirm')
        emit('update:modelValue', false)
    }
</script>
